/* eslint-disable no-unused-vars */
import JSZip from "jszip";
import React, { useEffect } from "react";
import * as XLSX from "xlsx";
import {
  GetAllDimenssionByCategory,
  GetAllPropertyByCategory,
  GetBudgetCategory,
  ImageCreation,
} from "../../../axios";
import { Button } from "../../../components";
import { colors } from "../../../configs";
import Strings from "../../../translations";

const BudgetItemFileUpload = (props) => {
  const {
    errorMessage,
    handleChangeData = () => {},
    initialValue = {},
    actionType,
    handleModalClose,
    budget_Name,
    budget_id,
  } = props;
  const cancelButton = Strings["Country.CreateCountryCancelButton"],
    saveButton = Strings["Country.CreateCountrySaveButton"],
    updateBtn = Strings["Country.CreateCountryUpdateButton"];

  const [selectedFile, setSelectedFile] = React.useState({
    value: initialValue.selectedFile ? initialValue.selectedFile : "",
    error: false,
    success: false,
  });
  const [uploadFile, setUploadFile] = React.useState([]);
  const [emptyFileAlert, setEmptyFileAlert] = React.useState(false);
  const [uploadFlag, setFlag] = React.useState(false);
  const [ItemCategoryDropDown, SetItemCategoryDropDown] = React.useState([]);
  const [itemProperty, setItemProperty] = React.useState(
    initialValue.propertiesdetails
      ? initialValue.propertiesdetails.map((p) => ({
          value: {
            property_id: p.item_property_id,
            property_name: `Property ${p.item_property_id}`,
            property_value: p.item_property_value || "",
          },
          error: false,
          success: false,
        }))
      : []
  );

  const [itemDimession, setItemDimenssion] = React.useState(
    initialValue.dimensionsdetails
      ? initialValue.dimensionsdetails.map((d) => ({
          value: {
            dimension_id: d.item_dimension_id,
            dimension_name: d.dimension_name,
            dimension_value: d.item_dimension_value || "",
          },
          error: false,
          success: false,
        }))
      : []
  );
  const [loading, setLoading] = React.useState(false);
  const [otherValuesArray, setOtherFiledsValues] = React.useState([]);
  const [categoryName, setCategoryName] = React.useState();

  useEffect(() => {
    if (uploadFlag && uploadFile.length > 0) {
      getAllActiveItemCategory();
      getAllPropertyByCategory(categoryName);
      getAllDimenssionByCategory(categoryName);
    }

    setEmptyFileAlert(uploadFile.length === 0);
  }, [uploadFile, uploadFlag, categoryName]);

  const handleChangeFile = (e) => {
    setSelectedFile(e.target.value);
    if (e.target.files) {
      const reader = new FileReader();
      reader.onload = (e) => {
        const data = e.target.result;
        const workbook = XLSX.read(data, { type: "array" });
        const sheetName = workbook.SheetNames[0];
        const worksheet = workbook.Sheets[sheetName];
        const json = XLSX.utils.sheet_to_json(worksheet);
        setUploadFile(json);
        setFlag(true);
        const range = XLSX.utils.decode_range(worksheet["!ref"]);
        const startColIndex = XLSX.utils.decode_col("X");
        const lastColIndex = range.e.c;
        const headerRow = range.s.r;
        const headers = [];

        for (let c = startColIndex; c <= lastColIndex; c++) {
          const headerCell =
            worksheet[XLSX.utils.encode_cell({ r: headerRow, c })];
          headers.push(headerCell ? headerCell.v : `Col_${c}`);
        }

        const rows = [];

        for (let r = headerRow + 1; r <= range.e.r; r++) {
          const rowObj = {};
          let isEmpty = true;

          for (let c = startColIndex; c <= lastColIndex; c++) {
            const cell = worksheet[XLSX.utils.encode_cell({ r, c })];
            const headerCell =
              worksheet[XLSX.utils.encode_cell({ r: headerRow, c })];
            const header = headerCell ? headerCell.v : `Col_${c}`;
            const value = cell ? cell.v : null;

            if (value !== null && value !== "") isEmpty = false;
            rowObj[header] = value;
          }

          if (!isEmpty) {
            rows.push(rowObj);
          }
        }

        setOtherFiledsValues(rows);
      };
      reader.readAsArrayBuffer(e.target.files[0]);
    }
  };

  const getAllPropertyByCategory = (categoryIdObj) => {
    const categoryId = categoryIdObj;
    setLoading(true);
    GetAllPropertyByCategory(categoryId)
      .then((res) => {
        const data = res.data.data.properties;
        const result = data.map((ele) => {
          const existing = itemProperty.find(
            (p) => p.value.property_id === ele.id
          );

          return {
            key: ele.id,
            label: ele.name,
            value: existing ? existing.value : "",
          };
        });
        setItemProperty(result);
        console.log("itemProperty state:", result);
        setLoading(false);
      })
      .catch((e) => {
        setLoading(false);
      });
  };

  const getAllDimenssionByCategory = (categoryIdObj) => {
    const categoryId = categoryIdObj;
    setLoading(true);
    GetAllDimenssionByCategory(categoryId)
      .then((res) => {
        const data = res.data.data.dimensions;
        const result = data.map((ele) => {
          const existing = itemDimession.find(
            (d) => d.value.dimension_id === ele.id
          );
          return {
            key: ele.id,
            label: ele.name,
            value: existing ? existing.value.dimension_value : "",
          };
        });

        setItemDimenssion(result);
        setLoading(false);
      })
      .catch((e) => {
        setLoading(false);
      });
  };
  const BASE_FILE_URL = process.env.REACT_APP_BASE_URL2;

  const mapValuesToPayload = (
    itemProperty,
    itemDimession,
    otherValuesArray
  ) => {
    const properties = [];
    const dimensions = [];

    itemProperty.forEach((prop) => {
      if (otherValuesArray?.hasOwnProperty(prop.label)) {
        properties.push({
          property_id: prop.key,
          property_value: otherValuesArray[prop.label],
        });
      }
    });

    itemDimession.forEach((dim) => {
      if (otherValuesArray?.hasOwnProperty(dim.label)) {
        dimensions.push({
          dimension_id: dim.key,
          dimension_value: otherValuesArray[dim.label],
        });
      }
    });

    return { properties, dimensions };
  };

  const getAllActiveItemCategory = () => {
    setLoading(true);
    GetBudgetCategory(budget_id)
      .then((res) => {
        let data = res.data.data;
        const result = data.map((ele) => ({
          key: ele.categoryid,
          value: ele.categoryid,
          label: ele.categoryname,
        }));
        setLoading(false);
        SetItemCategoryDropDown(result);
        const categoryName = result.filter(
          (item) => item?.label === uploadFile[0]?.["Category"]
        );
        setCategoryName(categoryName[0]?.key);
      })
      .catch((e) => {
        setLoading(false);
      });
  };

  const convertBase64 = (file) =>
    new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result);
      reader.onerror = (err) => reject(err);
    });

  const handleSaveData = () => {
    let itemList = uploadFile;

    const data = itemList.map((item, index) => {
      const payload = mapValuesToPayload(
        itemProperty,
        itemDimession,
        otherValuesArray[index]
      );

      return {
        control_number: item["Control Number"],
        budget_name: budget_Name,
        budget_id: budget_id,
        item_group_name: item.Group,
        item_subgroup_name: item["Sub Group"],
        item_category_name: item["Category"],
        item_code: item["Item Code"],
        description: item["Description"],
        short_description: item["Short Description"],
        name: item["Item Name"],
        budget_quantity: item["Budget Qty"],
        budget_uom: item["Budget UOM"],
        budget_currency: item["Budget Currency"],
        budget_price: item["Budget Unit Price"]
          ? item["Budget Unit Price"]
          : null,
        qtyByRoom: null,
        perLevel: null,
        rooms: null,
        qty: 0,
        tags: item["Tags"],
        total_units: null,
        brand: null,
        totalunits: null,
        actual_uom: item["Actual UOM"] ? item["Actual UOM"] : null,
        actual_quantity: item["Actual Qty"] ? item["Actual Qty"] : null,
        actual_currency: item["Actual Currency"]
          ? item["Actual Currency"]
          : null,
        actual_price: item["Actual Unit Price"]
          ? item["Actual Unit Price"]
          : null,
        ship_to_vendor: item["Ship To Vendor"] ? item["Ship To Vendor"] : null,
        specified_vendor: item["Specified Vendor"]
          ? item["Specified Vendor"]
          : null,
        vendor: item["Vendor"] ? item["Vendor"] : null,
        model_number: item["Model Number"] ? item["Model Number"] : null,
        notes: null,
        size: null,
        properties: payload?.properties,
        dimensions: payload?.dimensions,
        file_path: item.file_path || "",
      };
    });
    console.log("Mapped Data (Transformed):", data);
    const selectedFile = { data: JSON.parse(JSON.stringify(data)) };
    handleChangeData(selectedFile);
  };

  const handleExcelUploadForImage = async (e) => {
    const file = e?.target?.files?.[0];
    if (!file) return;

    try {
      setLoading(true);

      const data = await file.arrayBuffer();
      const workbook = XLSX.read(data, { type: "array" });
      const sheetName = workbook.SheetNames[0];
      const worksheet = workbook.Sheets[sheetName];
      const jsonData = XLSX.utils.sheet_to_json(worksheet, { defval: "" });

      const range = XLSX.utils.decode_range(worksheet["!ref"]);
      const startColIndex = XLSX.utils.decode_col("X");
      const lastColIndex = range.e.c;
      const headerRow = range.s.r;

      const headers = [];
      for (let c = startColIndex; c <= lastColIndex; c++) {
        const headerCell =
          worksheet[XLSX.utils.encode_cell({ r: headerRow, c })];
        headers.push(headerCell ? headerCell.v : `Col_${c}`);
      }

      const otherRows = [];
      for (let r = headerRow + 1; r <= range.e.r; r++) {
        const rowObj = {};
        let isEmpty = true;

        for (let c = startColIndex; c <= lastColIndex; c++) {
          const cell = worksheet[XLSX.utils.encode_cell({ r, c })];
          const headerCell =
            worksheet[XLSX.utils.encode_cell({ r: headerRow, c })];
          const header = headerCell ? headerCell.v : `Col_${c}`;
          const value = cell ? cell.v : null;

          if (value !== null && value !== "") isEmpty = false;
          rowObj[header] = value;
        }

        if (!isEmpty) {
          otherRows.push(rowObj);
        }
      }

      setOtherFiledsValues(otherRows);

      // Read images from Excel ZIP
      const zip = await JSZip.loadAsync(file);
      const imageFiles = Object.entries(zip.files).filter(([path]) =>
        path.startsWith("xl/media/")
      );

      const uploadedImages = [];

      for (const [path, zipEntry] of imageFiles) {
        const blob = await zipEntry.async("blob");
        const base64 = await new Promise((resolve) => {
          const reader = new FileReader();
          reader.onloadend = () => resolve(reader.result);
          reader.readAsDataURL(blob);
        });

        const cleanBase64 = base64.replace(/^data:.*;base64,/, "");
        const fileName = path.split("/").pop();
        const extension = fileName.split(".").pop();

        const formData = {
          file_data: cleanBase64,
          file_extension: extension,
          file_name: fileName,
        };

        const res = await ImageCreation(formData);
        const filePath = res?.data?.data?.file_path;

        uploadedImages.push(filePath || "");
      }
      const finalData = jsonData.map((row, index) => {
        const relative = uploadedImages[index] || "";
        const fullUrl = relative ? `${BASE_FILE_URL}${relative}` : "";

        return {
          ...row,
          file_path: fullUrl,
        };
      });
      setUploadFile(finalData);
      setFlag(true);
    } catch (err) {
      console.error("Error reading Excel with images:", err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="modalFormContainer">
      <h2 className="mb-3">{"Upload CSV File"}</h2>
      {errorMessage && <h6 style={{ color: "red" }}>{errorMessage}</h6>}
      {emptyFileAlert && (
        <h6 style={{ color: "red" }}>No Records Found To Upload</h6>
      )}
      <input
        type="file"
        // onChange={handleChangeFile}
        onChange={(e) => {
          if (actionType === "imageExcel") {
            handleExcelUploadForImage(e);
          } else {
            handleChangeFile(e);
          }
        }}
        accept=".csv, .xlsx"
        style={{
          marginTop: "1.5rem",
        }}
      />
      <div
        style={{
          display: "flex",
          marginTop: "1.5rem",
          justifyContent: "space-between",
        }}
      >
        <Button
          buttonName={cancelButton}
          buttonStyle={{ backgroundColor: colors.darkgrey }}
          onClick={() => {
            handleModalClose();
          }}
        />
        <Button
          buttonName={actionType === "add" ? saveButton : updateBtn}
          buttonStyle={{ backgroundColor: colors.primary }}
          disable={uploadFile.length == 0 ? true : false}
          onClick={handleSaveData}
        />
      </div>
    </div>
  );
};

export default BudgetItemFileUpload;
